import { render, staticRenderFns } from "./item-clicks-table.vue?vue&type=template&id=3d311ee3&scoped=true&"
import script from "./item-clicks-table.vue?vue&type=script&lang=js&"
export * from "./item-clicks-table.vue?vue&type=script&lang=js&"
import style0 from "./item-clicks-table.vue?vue&type=style&index=0&id=3d311ee3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d311ee3",
  null
  
)

export default component.exports